// extracted by css-extract-rspack-plugin
export default {"cls1":"Tooltip-cls1_Jga","cls2":"Tooltip-cls2_tDM Tooltip-cls1_Jga"};